var _style, _g, _g2, _g3, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBar1White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9D9D9D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500.8,
    cy: 499.5,
    r: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M957.9,147.7c-17.2-42.2-46.5-78-84.8-103.6c-37.5-25-81.6-39-127.5-40.4c-44.5-1.3-88.8,11.6-128,37.5 C580,66,549.3,101.9,531.3,142.3c-6.2,13.9-4.7,29,4.2,41.3c9,12.4,23.9,19.5,37.8,18.1c12.3-1.3,22.5-9.1,28.1-21.5 c12.5-28,31.4-51.6,54.5-68.2c24-17.2,51.5-26.8,81.9-28.4c30.7-1.7,61.3,6.8,88.3,24.5c26.3,17.3,47.2,42.4,58.8,70.9 c22.5,55.3,9.1,120.1-34.2,165.1c-41.6,43.2-108.3,55.3-170,30.9c-19.7-7.8-39,0.6-46.8,20.4c-3.9,9.8-4.2,21.1-0.8,31 c3.9,11.4,12.4,20.2,23.9,24.8c27.5,10.9,56.4,16.3,85.5,16.3c15.7,0,31.5-1.6,47-4.8c43.8-9.1,84.4-30.5,117.5-62.1 c32.7-31.1,54.7-72.3,63.6-118.9C979.3,236.7,974.8,189.1,957.9,147.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.2,596.8c109-113.1,217.9-226.9,326.9-339.9c17.7-18.4,5.2-51.3-20.9-51.3c-236.1,0-476.9,0-712.5,0 c-17.6,0-25.9,16-25.2,31.4c-0.2,6.5,1.8,13.1,6.9,19.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.2,0.4,0.5,0.6,0.7 c0.1,0.1,0.2,0.2,0.3,0.4c111.7,115.8,223.4,231.7,335.1,347.5v212.2l-34.2,39.2H181c-29.6,0-45,21.6-45,42.9 c0,21.3,15.5,42.9,45,42.9h403.8c29.6,0,45-21.6,45-42.9c0-21.3-15.5-42.9-45-42.9H465.7l-34.6-38.6V596.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBar1White);
export default __webpack_public_path__ + "static/media/Icon_bar1_white.ab938c84.svg";
export { ForwardRef as ReactComponent };